module.exports = __webpack_public_path__ + "img/ascend_gold48.c84875c7.png";